<main class="main">
    <page-header *ngIf="pageHeader"></page-header>
    <router-outlet></router-outlet>
</main>
<app-footer></app-footer>